import {
  Component,
  OnInit
} from '@angular/core';
import { SeoService } from '../../home';

@Component({
  selector: 'procedures-introduce',
  template: require('./procedures-introduce.component.html'),
  providers: [SeoService],
})

export class ProceduresIntroduceComponent implements OnInit{

  public constructor(private seo: SeoService){}

  public ngOnInit(){
    this.seo.setTitle('DG Express - Các Dịch Vụ Chăm Sóc Khách Hàng Tận Tình, Chu Đáo');
    this.seo.setTag('description','Tư vấn và lựa chọn nguồn hàng trên các website thương mại điện tử hàng đầu Trung Quốc. Vận chuyển hàng hóa từ Trung Quốc về Việt Nam nhanh gọn, an toàn. Thanh toán hộ, chuyển tiền (Ngân hàng/tiền mặt) sang Trung Quốc. Nạp tiền vào tài khoản Alipay nhanh gọn (5 phút)');
    this.seo.setTag('robots','order, follow');
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/orders/procedures-introduce/procedures-introduce.component.ts